import React from 'react';

const CustomTwoPage = () => <div>Custom Page 2</div>;

export default CustomTwoPage;
